import {
  container,
  title,
  mlAuto,
  mrAuto,
  description,
  infoColor,
} from '../../../material-kit-pro-react.jsx'

const styles = {
  container,
  title,
  mrAuto,
  mlAuto,
  description,
  card: {},
  cardBody: {
    padding: '15px',
    '& form': {
      marginBottom: '0',
    },
  },
  cardForm: {
    margin: '0 0 0 14px',
    padding: 0,
    top: 10,
  },
  socialLine: {
    marginTop: '100px',
    padding: '.9375rem 0px',
    '& $border': {
      borderRight: '1px solid rgba(0,0,0,0.12)',
    },
    '& $border:last-child': {
      border: 0,
    },
  },
  textCenter: {
    textAlign: 'center !important',
  },
  white: {
    backgroundColor: '#fff',
  },
  cyan: {
    background: infoColor,
    '& $border': {
      borderColor: 'rgba(0,0,0,0.3)',
    },
  },
  bigIcons: {
    '& a': {
      margin: 0,
      width: '100% !important',
      padding: '15px 25px',
      fontSize: '30px',
    },
    '& svg': {
      lineHeight: '90px',
    },
  },
  subscribeLine: {
    padding: '1.875rem 0px',
    '& $card': {
      marginTop: '30px',
    },
    '& form': { margin: '0px' },
    '& $formFix': { paddingTop: '0px' },
    '&$subscribeLineImage:after': {
      position: 'absolute',
      zIndex: 1,
      width: '100%',
      height: '100%',
      display: 'block',
      left: 0,
      top: 0,
      content: "''",
      backgroundColor: 'rgba(0,0,0,0.66)',
    },
  },
  formFix: {},
  subscribeLineWhite: {
    backgroundColor: '#fff',
    '& $subscribeButton': {
      top: '-6px',
    },
  },
  subscribeLineImage: {
    position: 'relative',
    backgroundPosition: 'top center',
    backgroundSize: 'cover',
    '& $container': {
      zIndex: 2,
      position: 'relative',
    },
    '& $title': {
      color: '#fff',
    },
    '& $description': {
      color: '#999',
    },
  },
  subscribeButton: {},
  border: {},
}

export default styles



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-pro-react/views/componentsSections/preFooter.jsx